import { RootState } from "@/store/store";
import { ResourceType } from "@/services/cloudchipr.api";
import { resourcesGridSliceSelector } from "@/store/resources-grid/selectors/resourcesGridSliceSelector";
import { selectedResourcesByMasterIdSelector } from "@/store/resources-grid/selectors/grid/selection/selectedResourcesByMasterIdSelector";
import { AllTypeResourceItem } from "@/store/resources-grid/utils/types/resources";

export const selectedResourcesByResourceTypeSelector = (
  state: RootState,
  resourceType: ResourceType,
): (AllTypeResourceItem | undefined)[] | undefined => {
  const slice = resourcesGridSliceSelector(state);

  const allGrids = slice.grids;

  if (!allGrids) {
    return;
  }

  const masterGridId = Object.entries(allGrids)
    .find(([, grid]) => grid?.resourceType === resourceType)
    ?.at(0) as string;

  if (!masterGridId) {
    return;
  }

  return selectedResourcesByMasterIdSelector(state, masterGridId);
};
